const de = {
  title: 'gKI-Chat',
  copyCode: 'Code kopieren',
  placeholder: 'Geben Sie Ihre Nachricht ein...',
  error: 'Es ist ein Fehler aufgetreten',
  apiKeyManagement: 'API-Schlüssel Verwaltung',
  topWarning:
    'Bitte beachten Sie: Dies ist ein Testsystem, das nur ausgewählten Nutzern zugänglich ist. Melden Sie Fehler und Probleme an den RZ-Support oder an support@artcodix.com.',
  warning: 'THRO gKI-Chat kann Fehler machen. Überprüfen Sie wichtige Informationen.',
  possibilities: 'Möglichkeiten',
  limitations: 'Limitationen',
  newChat: 'Neuer Chat',
  infoBoxes: {
    contextUnderstanding: {
      title: 'Kontextverständnis',
      text: 'Merkt sich, was vorab in der Konversation gesagt wurde.'
    },
    iteration: {
      title: 'Iteration',
      text: 'Erlaubt nachträgliche Korrekturen generierter Ergebnisse.'
    },
    formatting: {
      title: 'Formatierung',
      text: 'Gibt generierte Ergebnisse in gewünschter Form aus.'
    },
    dataPrivacy: {
      title: 'Datenschutz',
      text: 'Dies ist ein in Rosenheim betriebenes Sprachmodell. Ihre Daten verlassen Rosenheim nicht und Ihre Anfragen werden nicht gespeichert.'
    },
    incomplete: {
      title: 'Unvollständig',
      text: 'Generiert gelegentlich falsche Informationen.'
    },
    attention: {
      title: 'Vorsicht',
      text: 'Generiert gelegentlich gefährdende oder voreingenommene Informationen.'
    },
    limitation: {
      title: 'Limitierung',
      text: 'Das Sprachmodell greift ausschließlich auf Wissen bis Dezember 2024 zu.'
    },
    multiModelSupport: {
      title: 'Multi-Modell-Unterstützung',
      text: 'Wählen Sie aus verschiedenen Open-Weight-Modellen für Ihre Anfragen aus.'
    },

    knowledgeLimits: {
      title: 'Wissensgrenzen',
      text: 'Open-Weight-Modelle haben einen Wissensstand bis zum Trainingszeitpunkt und kennen keine aktuellen Ereignisse.'
    },

    chatHistory: {
      title: 'Chatverlauf',
      text: 'Ihre Konversationen werden gespeichert und können jederzeit fortgesetzt oder durchsucht werden.'
    },

    hallucinations: {
      title: 'Halluzinationen',
      text: 'Die Modelle können gelegentlich falsche oder erfundene Informationen als Fakten präsentieren.'
    },

    fileUpload: {
      title: 'Datei-Upload',
      text: 'Laden Sie Dokumente, Bilder und andere Dateien hoch, um sie mit der KI zu analysieren.'
    },

    performance: {
      title: 'Rechenleistung',
      text: 'Komplexe Anfragen können aufgrund begrenzter lokaler Ressourcen länger dauern als bei Cloud-Diensten.'
    },

    pluginsAndTools: {
      title: 'Plugins & Werkzeuge',
      text: 'Nutzen Sie integrierte Werkzeuge für Websuche, Code-Ausführung und weitere Funktionen.'
    },

    languageQuality: {
      title: 'Sprachqualität',
      text: 'Open-Weight-Modelle sind primär auf Englisch trainiert – deutsche Antworten können weniger präzise sein.'
    },

    privacy: {
      title: 'Datenschutz',
      text: 'Self-hosted Lösung – Ihre Daten bleiben auf unseren Servern in Rosenheim und werden nicht an Dritte weitergegeben.'
    }
  },
  rooms: {
    chat: 'Chat',
    finance: 'Finanzen',
    research: 'Forschung',
    marketing: 'Marketing',
    programming: 'Programmierung',
    legal: 'Rechtsberatung',
    social: 'Social Media'
  },
  partners: {
    finance: {
      name: 'Finn Anzer',
      text: 'Sie unterhalten sich nun mit einem fiktiven Finanzberater. Was möchten Sie über Finanzen wissen?'
    },
    research: {
      name: 'Florian Forsch',
      text: 'Sie unterhalten sich nun mit einem fiktiven Forscher. Was möchten Sie über Forschungen wissen?'
    },
    marketing: {
      name: 'Mark Eting',
      text: 'Sie unterhalten sich nun mit einem fiktiven Marketingberater. Was möchten Sie über Marketing wissen?'
    },
    programming: {
      name: 'Paul Python',
      text: 'Sie unterhalten sich nun mit einem fiktiven Programmierer. Was möchten Sie über Programmieren wissen?'
    },
    legal: {
      name: 'Richard Recht',
      text: 'Sie unterhalten sich nun mit einem fiktiven Rechtsberater. Was möchten Sie über Rechte wissen?'
    },
    social: {
      name: 'Susi Sozial',
      text: 'Sie unterhalten sich nun mit einem fiktiven Social Media Manager. Was möchten Sie über Social Media wissen?'
    }
  },
  dialogs: {
    deleteChat: {
      title: 'Chat löschen',
      message: 'Wollen Sie den Chat wirklich löschen?'
    }
  },
  feedbackButton: 'Feedback abgeben',
  chatPortalButton: 'Zum Chatportal',
  tooltips: {
    oneAttachmentOnly:
      'Es kann nur eine Datei pro Konversation hochgeladen werden. Erstellen Sie einen neuen Chat, um eine weitere Datei hochzuladen.'
  },
  apiKeys: {
    createDialog: {
      title: 'API-Schlüssel anlegen',
      description: 'Geben Sie dem API-Key einen Namen und eine Beschreibung.'
    },
    deleteDialog: {
      title: 'API-Schlüssel löschen',
      description: 'Wollen Sie diesen API-Schlüssel wirklich löschen?'
    },
    alerts: {
      failedCreate: 'Der API-Schlüssel konnte nicht angelegt werden.',
      failedDelete: 'Der API-Schlüssel konnte nicht gelöscht werden.',
      deleteSuccess: 'Der API-Schlüssel wurde gelöscht.',
      createSuccess: 'Der API-Schlüssel wurde angelegt.',
      info: 'Hier können Sie API-Schlüssel generieren, um die AI-API (<a href="https://inference.ai.artcodix.cloud" target="_blank"><b>https://inference.ai.artcodix.cloud</b></a>) in Ihren Applikationen verwenden zu können.'
    },
    showAPIKeyDialog: {
      title: 'Ihr API-Schlüssel',
      description:
        'Kopieren Sie den generierten API-Schlüssel, da er nach dem Schließen des Dialoges nicht mehr abrufbar ist.'
    },
    noRows: 'Noch keine API-Schlüssel vorhanden'
  }
};

export default de;
export type ChatTranslation = typeof de;
